import * as dictAPI from '../../data/org/dicts'
import * as salorAPI from '../../data/order/salor'

// initial state
const state = {
    sideMenuOpen: true,
    // 定时刷新通知信息任务ID
    notificationRefreshJobId: undefined,
    notificationDialogVisible: false,
    notificationLoading: false,
    todayDeliveryOrders: [],
    unAssignOrders: [],
    needPayAndExistDraftOrders: [],
}

// getters
const getters = {
    
}

// actions
const actions = {
    refreshNotificationData(context) {
        context.commit('setNotificationLoading', true)
        context.dispatch('getTodayDeliveryOrders')

        if (!!context.state.notificationRefreshJobId) {
            const tmpJobId = context.state.notificationRefreshJobId + ''
            context.commit('updateNotificationRefreshJobId', undefined)
            clearTimeout(tmpJobId)
        }

        dictAPI.queryDict({dict_type: 'salorNotificationConfigs'}).then(response => {
            const refreshIntervalTs = response.data.result.list.find(dict => dict.group_name === 'REFRESH_INTERVAL_TS')
            let nextTime = 2 * 60 * 60 * 1000

            if (!!refreshIntervalTs) {
                nextTime = parseInt(refreshIntervalTs.dict_value) * 1000
            }

            const tmpJobId = setTimeout(() => {
                context.dispatch('refreshNotificationData')
            }, nextTime)

            context.commit('updateNotificationRefreshJobId', tmpJobId)
        })
    },

    getTodayDeliveryOrders(context) {
        salorAPI.getTodayDeliveryOrders().then(response => {
            if (response.data.success) {
                context.commit('setTodayDeliveryOrders', response.data.result)
            } else {
                context.commit('setTodayDeliveryOrders', [])
            }
        })
        .catch(() => {})
        .then(() => {
            context.dispatch('getUnAssignOrders')
        })
    },

    getUnAssignOrders(context) {
        salorAPI.getUnAssignDocerOrders().then(response => {
            if (response.data.success) {
                context.commit('setUnAssignOrders', response.data.result)
            } else {
                context.commit('setUnAssignOrders', [])
            }
        })
        .catch(() => {})
        .then(() => {
            context.dispatch('getNeedPayAndExistDraftOrders')
        })
    },

    getNeedPayAndExistDraftOrders(context) {
        salorAPI.getNeedPayAndExistDraftDocOrders().then(response => {
            if (response.data.success) {
                context.commit('setNeedPayAndExistDraftOrders', response.data.result)
            } else {
                context.commit('setNeedPayAndExistDraftOrders', [])
            }
        }).catch(() => {})
        .then(() => {
            context.commit('setNotificationLoading', false)
            if (context.state.todayDeliveryOrders.length > 0 || context.state.unAssignOrders.length > 0 || context.state.needPayAndExistDraftOrders.length > 0) {
                context.commit('setNotificationDialogVisible', true)
            }
        })
    },
}

// mutations
const mutations = {
    // 更改菜单状态
    setSideMenuOpenState(state, open) {
        state.sideMenuOpen = open;
    },
    // 更改全局提示弹窗
    setNotificationDialogVisible(state, val) {
        state.notificationDialogVisible = val
    },
    // 更改通知弹窗loading状态
    setNotificationLoading(state, val) {
        state.notificationLoading = val
    },
    // 更新今日待交付订单列表
    setTodayDeliveryOrders(state, val) {
        state.todayDeliveryOrders = val
    },
    // 更新未分配制作订单列表
    setUnAssignOrders(state, val) {
        state.unAssignOrders = val
    },
    // 更新已传初稿未付款订单列表
    setNeedPayAndExistDraftOrders(state, val) {
        state.needPayAndExistDraftOrders = val
    },
    updateNotificationRefreshJobId(state, val) {
        state.notificationRefreshJobId = val
    },
}
  
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js